import { $json } from '../axios'
import { Message } from 'element-ui'
import store from '../local/cart'

export default Object.freeze({
  bind(el, { value }) {
    const id = value.id
    const type = value.type || 1
    let isCollected = !!value.is
    el.addEventListener('click', e => {
      e.preventDefault()
      e.stopPropagation()
      if (!store.state.isLogin) {
        store.commit('OPEN_LOGIN', document.querySelector('#sidebar'))
        return
      }
      const promise = isCollected ? $json.delete(`favorite/product/${id}`) : $json.post('favorite', {
        type: type,
        content: id
      })
      promise.then(res => {
        Message.success(res.msg)
        if (isCollected) {
          store.commit('UPDATA_FAVORITE_LIST',{
            fav_type: 1,
            fav_content: id
          })
        } else {
          store.commit('UPDATA_FAVORITE_LIST',{
            symbol: 1,
            id: res.data,
            fav_type: 1,
            fav_content: id
          })
        }
      })
    },{ passive: true })
  }
})


// WEBPACK FOOTER //
// ./resources/js/lib/directives/wish.js